import React, { useEffect, useState } from "react";
import OverviewCard from "./OverviewCard";
import GamesLeaderboard from "./GamesLeaderboard";
import ValorClashCard from "./ValorClashCard";
import AccountsLeaderboard from "./AccountsLeaderboard";
import Main from "../../components/layout/Main";
import { Col, Row } from "antd";
import { useLeaderboard } from "../../context/LeaderboardContext";

const LeaderboardIndex = () => {
  // ------------ Constants ------------
  const [gameLeaderboard, setGameLeaderboard] = useState([]);
  const [leaderboard, setLeaderboard] = useState([]);
  const [leaderboardProfileData, setLeaderboardProfileData] = useState([]);
  const [gameId, setGameId] = useState();

  const { loadLeaderboard, loadGameLeaderboard, leaderboardProfile } =
    useLeaderboard();

  // ------------ Handelers -------------
  const fetchLeaderboard = async () => {
    try {
      const response = await loadLeaderboard();
      setLeaderboard(response.data.data.leaderboard);

      const gameLeaderboardResponse = await loadGameLeaderboard();
      setGameLeaderboard(gameLeaderboardResponse.data.data.data);
      setGameId(gameLeaderboardResponse.data.data.data[0].gameId);
      const leaderboardProfileResponse = await leaderboardProfile();
      setLeaderboardProfileData(leaderboardProfileResponse.data.data);
    } catch (error) {
      console.log("Error fetching leaderboard", error);
    }
  };

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  return (
    <Main>
      <div className="section-main">
        <div className="section-headding">
          <h6>Overview</h6>
        </div>
        <div className="dashboard-container">
          <div className="overview-section">
            <OverviewCard data={leaderboardProfileData} />
          </div>
          <div className="games-leaderboard-main">
            <h3 className="game-leader-headding">Games Leaderboard</h3>
            <Row gutter={[32, 12]}>
              <Col span={24} md={12} className="games-leaderboard">
                <GamesLeaderboard
                  data={gameLeaderboard}
                  setGameId={setGameId}
                />
              </Col>
              <Col span={24} md={12} className="valorclash-card">
                <ValorClashCard gameId={gameId} />
              </Col>
            </Row>
          </div>
          <div className="accounts-leaderboard-section">
            <h3 className="game-leader-headding">Accounts Leaderboard</h3>
            <AccountsLeaderboard data={leaderboard} />
          </div>
        </div>
      </div>
    </Main>
  );
};

export default LeaderboardIndex;
